import { FormEvent, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../auth/AuthProvider";

export default function AdminLogin() {
  const { signIn, user, isAdmin, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!loading && user && isAdmin) {
      navigate("/admin", { replace: true });
    }
  }, [loading, user, isAdmin, navigate]);

  const onSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await signIn(email.trim(), password);
    } catch (err: unknown) {
      const code = (err as { code?: string }).code;
      setError(
        code === "auth/invalid-credential" || code === "auth/wrong-password"
          ? "E-posta veya şifre hatalı"
          : code === "auth/too-many-requests"
          ? "Çok fazla deneme — biraz sonra tekrar dene"
          : "Giriş başarısız"
      );
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="card w-full max-w-md p-8">
        <div className="flex items-center gap-3 mb-8">
          <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-primary to-primaryDeep grid place-items-center">
            <span className="font-extrabold text-white">W</span>
          </div>
          <div>
            <div className="font-extrabold text-lg leading-tight">WordRace</div>
            <div className="text-xs text-textMuted font-bold tracking-widest uppercase">
              Admin Paneli
            </div>
          </div>
        </div>

        <h1 className="text-2xl font-extrabold mb-2">Giriş yap</h1>
        <p className="text-sm text-textSecondary mb-6">
          Bu panel yalnızca moderatörler için. Normal oyuncular uygulamayı
          kullansın.
        </p>

        <form onSubmit={onSubmit} className="space-y-3">
          <div>
            <label className="block text-xs font-bold text-textMuted mb-1 tracking-wider uppercase">
              E-posta
            </label>
            <input
              type="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input"
              required
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-textMuted mb-1 tracking-wider uppercase">
              Şifre
            </label>
            <input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="input"
              required
            />
          </div>

          {error && (
            <div className="rounded-xl border border-danger/40 bg-danger/10 text-danger px-3 py-2 text-sm font-semibold">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={busy}
            className="btn-primary w-full disabled:opacity-60"
          >
            {busy ? "Giriş yapılıyor…" : "Giriş Yap"}
          </button>
        </form>

        <p className="text-xs text-textMuted mt-6 text-center">
          Yetki istemen gerekiyorsa super-admin ile iletişime geç.
        </p>
      </div>
    </div>
  );
}
